import { useMutation } from '@tanstack/vue-query'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async (code: string) =>
      await $fetch<string>(`/api/user/${authStore.user!.id}/verify-phone`, {
        method: 'POST',
        body: JSON.stringify({ code }),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: () => {
      authStore.updateUser({
        ...authStore.user!,
        phoneVerified: true,
      })
    },
  })
}
